import { useQuery } from '@tanstack/react-query'
import { strapiGet } from '@/lib/strapi'
import { useAppStore } from '@/lib/store/useAppStore'

export interface PwaInstall {
  documentId: string
  installId: string
  platform?: string | null
  displayMode?: string | null
  source?: string | null
  customerName?: string | null
  customerPhone?: string | null
  customerEmail?: string | null
  firstInstalledAt?: string | null
  lastSeenAt?: string | null
  lastCustomerUpdateAt?: string | null
  launchCount?: number | null
}

export interface PwaInstallReport {
  restaurant: { documentId: string; name: string; slug: string }
  summary: { total: number; linkedCustomers: number; anonymous: number }
  installs: PwaInstall[]
}

export function usePwaInstalls() {
  const restaurantId = useAppStore((s) => s.restaurantId)
  return useQuery({
    queryKey: ['pwa-installs', restaurantId],
    queryFn: () => strapiGet<PwaInstallReport>('/api/pwa-installs/me'),
    enabled: !!restaurantId,
    staleTime: 60_000,
  })
}
